import { render, staticRenderFns } from "./rwpendidikan.vue?vue&type=template&id=3de3cbce"
import script from "./rwpendidikan.vue?vue&type=script&lang=js"
export * from "./rwpendidikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports